var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-button',{staticClass:"delete-targeting-info",on:{"click":_vm.showModal}},[_vm._v(_vm._s(_vm.$t('delete.targeting.info')))]),_c('delete-targeting-info-modal',{attrs:{"visible":_vm.visible},on:{"cancel":_vm.handleCancel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }